import { render, staticRenderFns } from "./ComplexGateway.vue?vue&type=template&id=35e040bf&scoped=true&"
import script from "./ComplexGateway.vue?vue&type=script&lang=js&"
export * from "./ComplexGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e040bf",
  null
  
)

export default component.exports